import type { YesNo } from '@libs/analytics';
import type { Product } from '@libs/common-next';

import { isAutoshipBadgeEligible } from '@/utils/isAutoshipBadgeEligible';

export type ViewItemListAutoshipContext = Readonly<{
    isPlpAutoshipBadgeEnabled: boolean;
    isPerSkuSubscribedIndicatorEnabled: boolean;
    isSubscribedForTileSku: (tileSku: string) => boolean;
}>;

export function getExistingSubscriptionForViewItemList(
    product: Product,
    {
        isPlpAutoshipBadgeEnabled,
        isPerSkuSubscribedIndicatorEnabled,
        isSubscribedForTileSku,
    }: ViewItemListAutoshipContext
): YesNo {
    const { rawProductHit } = product;
    if (!rawProductHit) return 'no';

    const shouldShowAutoshipBadgeSlot = isPlpAutoshipBadgeEnabled && isAutoshipBadgeEligible(rawProductHit);

    const showsSubscribedWithAutoshipMessaging =
        shouldShowAutoshipBadgeSlot &&
        isPerSkuSubscribedIndicatorEnabled &&
        isSubscribedForTileSku(String(rawProductHit.sku ?? rawProductHit.id));

    return showsSubscribedWithAutoshipMessaging ? 'yes' : 'no';
}
